// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2307":"f4e43cb4","6205":"58fd7432","9645":"edf309f6"}[chunkId] + ".chunk.css";
};